export const wixappsOnlyMetaData = {
    containableByStructure: false
}
